<template>
  <div class="drainagePipeBody">
    <div style="display: flex; flex-direction: column; height: fit-content">
      <div style="display: flex; flex-direction: column">
        <el-form label-width="auto">
          <div style="display: flex; flex-direction: row">
            <el-form-item label="所属区域：">
              <el-select
                v-model="dictValueItem"
                value-key="dictValue"
                placeholder="请选择所属区域"
                @change="regionNameChange"
                style="width: 250px; margin-right: 10px"
              >
                <el-option
                  v-for="item in this.regionNameList"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <div>
              <el-form-item label="道路(小区)：">
                <el-select
                  v-model="roadListItem"
                  value-key="id"
                  allow-create
                  filterable
                  placeholder="请选择道路(小区)"
                  style="width: 250px; margin-right: 10px"
                >
                  <el-option
                    v-for="item in this.roadList"
                    :key="item.id"
                    :label="item.roadName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <el-form-item label="管道类型：">
                <el-select
                  v-model="queryForm.source"
                  placeholder="请选择管道类型"
                  style="width: 250px; margin-right: 10px"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="雨水管道" value="1"></el-option>
                  <el-option label="污水管道" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
            "
          >
            <el-button
              type="primary"
              style="margin-right: 10px"
              @click="submitSearch()"
              >查询</el-button
            >
            <el-button
              type="medium"
              style="margin-right: 10px"
              @click="resetOption()"
              >重置</el-button
            >
            <el-button
              type="primary"
              style="margin-right: 10px"
              @click="openUploadDialog()"
              >上传</el-button
            >
            <el-button
              type="primary"
              style="margin-right: 10px"
              @click="downloadExcel()"
              >导出</el-button
            >
            <el-button
              type="primary"
              style="margin-right: 10px"
              @click="downloadTemplateExcel()"
              >下载模板</el-button
            >
          </div>
          <el-divider />
        </el-form>
      </div>

      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="dataList"
          border
          fit
          highlight-current-row
        >
          <el-table-column label="ID" prop="id" align="center" width="100" />
          <el-table-column
            label="管网标号"
            prop="gdid"
            width="180"
            align="center"
          />
          <el-table-column
            label="所属区域"
            prop="regionName"
            width="150"
            align="center"
          />
          <el-table-column
            label="道路(小区)"
            prop="roadName"
            width="180"
            align="center"
          />
          <el-table-column
            label="管道类型"
            prop="source"
            width="120"
            align="center"
            :formatter="sourceFormat"
          />
          <el-table-column label="长度" prop="cd" width="100" align="center" />
          <el-table-column
            label="管材"
            prop="tubing"
            width="100"
            align="center"
          />
          <el-table-column
            label="埋设方式"
            prop="msfs"
            width="100"
            align="center"
          />
          <el-table-column
            label="本点号"
            prop="thisPointNumber"
            width="150"
            align="center"
          />
          <el-table-column
            label="上点号"
            prop="upPointNumber"
            width="150"
            align="center"
          />
          <el-table-column
            label="本点标高"
            prop="thisPointElevation"
            width="150"
            align="center"
          />
          <el-table-column
            label="上点标高"
            prop="upPointElevation"
            width="150"
            align="center"
          />
          <el-table-column
            label="本点埋深"
            prop="thisPointBurialDepth"
            width="150"
            align="center"
          />
          <el-table-column
            label="上点埋深"
            prop="upPointBurialDepth"
            width="150"
            align="center"
          />
          <el-table-column label="备注" prop=remarks" width="200" align="center"
          />
          <el-table-column
            label="所属单位"
            prop="unit"
            width="200"
            align="center"
          />
          <el-table-column
            label="探测日期"
            prop="tcrq"
            width="150"
            align="center"
          />
          <el-table-column
            label="埋设年代"
            prop="burialDate"
            width="150"
            align="center"
          />
          <el-table-column
            label="录入途径"
            prop="inputChannel"
            width="200"
            align="center"
          />
          <el-table-column
            label="易堵易冒"
            prop="blockBurst"
            width="200"
            align="center"
          />

          <el-table-column label="操作" prop="tpye" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="blockOrBurst(scope.row)"
                >设置易堵易冒
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--页码-->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryForm.current"
          :limit.sync="queryForm.size"
          @pagination="getLineByPageDto"
        />
      </div>
    </div>

    <el-dialog title="上传" :visible.sync="uploadDialogVisibleFlag" width="30%">
      <el-upload
        class="file-uploader"
        action="#"
        accept=".xlsx,.xls"
        :http-request="handlexlslFile"
        :show-file-list="false"
        :before-upload="beforeFileUpload"
      >
        <el-button size="medium" type="text">上传文件</el-button>
      </el-upload>

      {{ filename }}

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUploadFile()">上 传</el-button>
        <el-button @click="uploadDialogVisibleFlag = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.drainagePipeBody {
  width: auto;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}
</style>

<script>
import Pagination from '@/components/PaginationStyle1.vue';
import {
  blockOrBurst,
  blockOrBurstLine,
  exportExcelLine,
  getLineByPageDto,
  uploadExcelLine,
} from '@/api/pipenetmanagement';
import { getAccountManageMore } from '@/api/accountmanagement/accountmanagement';
import CommonFile from '@/api/common';
import { cameraDownload, getDictList } from '@/api/equipmentmanagement';
import { getCurrentFormattedDateTime } from '@/utils/TimeUtils';
import CommonApi from '@/api/common';

export default {
  name: 'DrainagePipe', //排水管道
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      dataList: [],
      total: 0,
      queryForm: {
        size: 10,
        current: 1,
        townCode: '',
        roadId: '',
        source: '',

        // flowDirection: "",
        // interfaceType: "",
        // pipeDiameter: "",
        // regionName: "",
        // tubing: "",
        // unit: ""
      },

      dictValueItem: {},
      roadList: [],
      roadListItem: {},

      queryRoadName: '',
      queryRoadId: 0,

      uploadDialogVisibleFlag: false,
      filename: '',
      uploadFile: null,

      regionNameList: [],
    };
  },
  methods: {
    async getDictList() {
      const result = await getDictList({ dictCode: 'town_code' });
      // console.log(result.data.data)
      this.regionNameList = result.data.data;
    },

    async getLineByPageDto() {
      this.listLoading = true;
      const result = await getLineByPageDto(this.queryForm);
      const list = result.data.data.records;
      this.dataList = [...list];
      this.total = result.data.data.total;
      this.listLoading = false;
    },
    resetOption() {
      this.queryForm = this.$options.data().queryForm;
      this.roadListItem = {};
      this.dictValueItem = {};
    },
    submitSearch() {
      this.queryForm.roadId = this.roadListItem.id;
      // console.log(this.queryForm)
      this.getLineByPageDto();
    },
    openUploadDialog() {
      this.uploadDialogVisibleFlag = true;
    },
    async submitUploadFile() {
      if (this.filename.length === 0) {
        this.$message.error('请上传文件！');
        return;
      }

      const result = await uploadExcelLine(this.uploadFile.file);

      if (result.data.code === 200) {
        this.$message({ message: '上传成功', type: 'success' });

        this.resetOption();
        this.getLineByPageDto();
      } else {
        this.$message.error(result.data.message);
      }
    },
    //上传文件
    handlexlslFile(file) {
      this.uploadFile = file;
    },
    beforeFileUpload(file) {
      this.filename = file.name;
      // console.log('文件名:', file.name);
    },
    async downloadExcel() {
      let req = { ...this.queryForm };

      this.queryForm.roadId = this.roadListItem.id;
      req.current = 1;
      req.size = Number.MAX_SAFE_INTEGER;
      // console.log(req)

      try {
        const result = await exportExcelLine(req);
        // 从响应中获取 Blob 对象
        const blob = result.data;
        // 创建一个 URL 对象
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        let fileName = '排水管道_' + getCurrentFormattedDateTime() + '.xlsx';
        link.setAttribute('download', fileName); // 设置下载文件名
        document.body.appendChild(link);
        link.click();

        // 释放 URL 对象
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Download error:', error);
      }
    },
    downloadTemplateExcel() {
      window.open(process.env.VUE_APP_BASE_URL + '/common/template/2');
    },
    regionNameChange() {
      this.roadList = [];
      this.queryForm.townCode = this.dictValueItem.dictValue;
      CommonApi.queryRoadList({
        townCode: this.dictValueItem.dictValue,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadList = res.data.data;
        } else {
          this.roadList = [];
        }
      });
    },
    blockOrBurst(obj) {
      blockOrBurstLine({ id: obj.id }).then((response) => {
        if (response.data.code === 200) {
          this.$message({ message: '修改成功', type: 'success' });

          this.getLineByPageDto();
        } else {
          this.$message.error(response.data.message);
        }
      });
    },
    afterCreated() {
      this.roadList = [];

      CommonApi.queryRoadList({
        townCode: this.$route.query.townCode,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadList = res.data.data;

          const roadId = this.$route.query.roadId;
          if (roadId != null) {
            // console.log(roadId)
            this.roadListItem = { id: parseInt(roadId) };

            this.$nextTick(() => {
              this.submitSearch();
            });
          }
        } else {
          this.roadList = [];
        }
      });
    },

    sourceFormat(row, column) {
      return row.source == 1 ? '雨水管道' : '污水管道';
    },
  },
  created() {
    const townCode = this.$route.query.townCode;

    if (townCode != null) {
      this.getDictList().then(() => {
        if (townCode !== null) {
          this.dictValueItem = { dictValue: townCode };
          //手动请求
          this.afterCreated();
        } else {
          this.getLineByPageDto();
        }
      });
    } else {
      this.getDictList();
      this.getLineByPageDto();
    }
  },
};
</script>
